











































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import MobileDetect from 'mobile-detect';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';

import type { Project } from '@/models/project';

import type { User } from '@/models/user';
import type { Trade } from '@/models/trade';
import type { Experience } from '@/models/experience';
import { experienceWebservice } from '@/webservices/experience';
import { topicWebservice } from '@/webservices/topic';
import { phaseWebservice } from '@/webservices/phase';
import { tradeWebservice } from '@/webservices/trade';
import { pmPhaseWebservice } from '@/webservices/pmphase';
import { lessonWebservice } from '@/webservices/lesson';
import { pmLessonWebservice } from '@/webservices/pmlesson';
import { tagWebservice } from '@/webservices/tag';

import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import type { Lesson } from '@/models/lesson';
import type { Phase } from '@/models/phase';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { Topic } from '@/models/topic';
import type { PMPhase } from '@/models/pmphase';
import type { PMLesson } from '@/models/pmlesson';
import type { Tag } from '@/models/tag';
import type { CompanySetting } from '@/models/companySetting';

import PreviewLessons from '@/components/knowledge/lessons/PreviewLessons.vue';
import WysiwygEditor from '../prine/WysiwygEditor.vue';
import type { Company } from '@/models/company';
import type { XLesson } from '@/models/xlesson';
import type { XProcess } from '@/models/xprocess';
import type { XSubProcess } from '@/models/xsubprocess';
import { xProcessWebservice } from '@/webservices/xprocess';
import { xLessonWebservice } from '@/webservices/xlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { LessonLike } from '@/helpers/types/LessonLike';

@Component({
    name: 'TransferExperience',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        ConfirmModal,
        ProjectChooser,
        PreviewLessons,
        WysiwygEditor,
    },
})
export default class TransferExperience extends Vue {
    private experiences = Array<Experience>();
    private experienceId: string;

    private errorMsg: string = '';
    private disabled: boolean = false;

    private experience: Experience = {} as Experience;

    // Trade
    private lesson: Lesson = {} as Lesson;
    private lessons = new Array<Lesson>();
    private pmLesson: PMLesson = {} as PMLesson;
    private pmLessons = new Array<PMLesson>();
    private xLesson: XLesson = {} as XLesson;
    private xLessons = new Array<XLesson>();

    private insight: string = '';
    private mandatory: boolean = false;

    private topics: Topic[] = new Array<Topic>();
    private trades: Trade[] = new Array<Trade>();
    private phases: Phase[] = new Array<Phase>();
    private tags = new Array<Tag>();

    private selectedTrade: Trade | null = null;
    private selectedPhases: Phase[] = new Array<Phase>();
    private selectedTopic: Topic | null = null;

    private selectedTags = new Array<Tag>();

    // PM
    private pmPhases: PMPhase[] = new Array<PMPhase>();
    private pmSubPhases: PMSubPhase[] = new Array<PMSubPhase>();

    private selectedPMPhase: PMPhase | null = null;
    private selectedPMSubPhase: PMSubPhase | null = null;
    // X
    private xProcesses: XProcess[] = new Array<XProcess>();
    private xSubProcesses: XSubProcess[] = new Array<XSubProcess>();

    private selectedXProcess: XProcess | null = null;
    private selectedXSubProcess: XSubProcess | null = null;

    private parentLesson: LessonLike | null = null;
    private checkedParentLesson: LessonLike[] = new Array<LessonLike>();

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('project/selectedProject') private selectedProject: Project;

    @Getter('account/company') private company: Company;
    @Getter('utils/currentLocale') private currentLocale: string;

    // Mounted is called initially
    private mounted() {
        // Fetch the experience id from the params
        this.experienceId = this.$route.query.experienceId.toString();

        // Load Trade related data
        this.loadExperience();
        this.loadTags();
        this.loadTopics();
        this.loadTrades();
        this.loadPhases();
        this.loadPMPhases();
        this.loadxProcess();
        this.$store.commit('utils/setCurrentRoutePath', '/experiences/transfer');
    }

    get language() {
        return this.$i18n.locale;
    }

    private selectedParentLesson(value: LessonLike[]) {
        this.checkedParentLesson = value;
        if (value.length !== 0) {
            this.parentLesson = value[0];
        } else {
            this.parentLesson = null;
        }
    }

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    private loadExperience() {
        // Load the experience by id
        experienceWebservice
            .getById(this.experienceId)
            .then((response) => {
                this.experience = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadTopics() {
        topicWebservice
            .load()
            .then((response) => {
                const filteredTopics = response.data.filter((topic: Topic) => {
                    return topic.title !== 'Nicht zugeordnete Lehren';
                });

                this.topics = filteredTopics.sort((a: Topic, b: Topic) => {
                    return a.title.localeCompare(b.title);
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadPhases() {
        phaseWebservice
            .load()
            .then((response) => {
                this.phases = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadTrades() {
        tradeWebservice
            .load(false)
            .then((response) => {
                this.trades = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadPMPhases() {
        pmPhaseWebservice
            .load()
            .then((response) => {
                this.pmPhases = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadxProcess() {
        xProcessWebservice
            .load()
            .then((response) => {
                this.xProcesses = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadTags() {
        tagWebservice
            .load()
            .then((response) => {
                this.tags = response.data;
                this.selectedTags = this.tags.filter((tag) => tag.default);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private loadLessons() {
        if (this.selectedTopic && this.selectedTrade) {
            lessonWebservice
                .load(this.selectedTrade.id, this.selectedTopic.id)
                .then((res) => {
                    this.lessons = res.data;
                })
                .catch((err: Error) => {
                    console.log(err);
                });
        }
    }

    private loadPmLessons() {
        if (this.selectedPMPhase && this.selectedPMSubPhase) {
            pmLessonWebservice
                .load(this.selectedPMSubPhase.id)
                .then((res) => {
                    this.pmLessons = res.data;
                })
                .catch((err: Error) => {
                    console.log(err);
                });
        }
    }

    private loadXLessons() {
        if (this.selectedXProcess && this.selectedXSubProcess) {
            xLessonWebservice
                .load(this.selectedXSubProcess.id)
                .then((res) => {
                    this.xLessons = res.data;
                })
                .catch((err: Error) => {
                    console.log(err);
                });
        }
    }

    private goBack() {
        this.$router.go(-1);
    }

    private bkpTrade({ bkp, title }) {
        return `${bkp} ${title}`;
    }

    private pmPhaseSelected() {
        if (this.selectedPMPhase != null) {
            if (this.selectedPMSubPhase != null && this.selectedPMSubPhase.pm_phase_id !== this.selectedPMPhase.id) {
                this.selectedPMSubPhase = null;
            }
            this.pmSubPhases = this.selectedPMPhase.sub_phases;
            this.loadPmLessons();
        }
    }

    private xProcessSelected() {
        if (this.selectedXProcess != null) {
            if (
                this.selectedXSubProcess != null &&
                this.selectedXSubProcess.x_process_id !== this.selectedXProcess.id
            ) {
                this.selectedXSubProcess = null;
            }
            this.xSubProcesses = this.selectedXProcess.x_sub_processes;
            this.loadXLessons();
        }
    }

    private saveInTrades() {
        this.disabled = true;
        if (!this.validateTradeLesson()) {
            this.disabled = false;
            return 0;
        }
        // Check if it's a trade or PM
        if (this.selectedTrade && this.selectedTopic) {
            this.lesson.insight = this.insight;
            this.lesson.mandatory = this.mandatory;

            // tslint:disable-next-line:max-line-length
            lessonWebservice
                .store(
                    this.lesson,
                    this.selectedTrade.id,
                    this.selectedTopic.id,
                    this.selectedPhases,
                    this.selectedTags,
                    this.experience.user_id,
                    this.selectedProject.id,
                    this.parentLesson as Lesson
                )
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 7000,
                        message: this.$t('toastMessages.store.experience').toString(),
                        type: 'is-success',
                    });

                    // The experience can now be deleted
                    experienceWebservice.remove(this.experience);

                    // Redirect to the list of experiences
                    this.$router.push('/experiences');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private saveInPM() {
        this.disabled = true;
        if (!this.validatePMLesson()) {
            this.disabled = false;
            return 0;
        }

        // Check if it's a trade or PM
        if (this.selectedPMPhase && this.selectedPMSubPhase) {
            this.pmLesson.insight = this.insight;
            this.pmLesson.mandatory = this.mandatory;

            // tslint:disable-next-line:max-line-length
            pmLessonWebservice
                .store(
                    this.pmLesson,
                    this.selectedPMSubPhase.id,
                    this.mandatory,
                    this.selectedTags,
                    this.experience.user_id,
                    this.selectedProject.id,
                    this.parentLesson as PMLesson
                )
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 7000,
                        message: this.$t('toastMessages.store.experience').toString(),
                        type: 'is-success',
                    });

                    // The experience can now be deleted
                    experienceWebservice.remove(this.experience);

                    // Redirect to the list of experiences
                    this.$router.push('/experiences');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private saveInX() {
        this.disabled = true;
        if (!this.validateXLesson()) {
            this.disabled = false;
            return 0;
        }

        // Check if it's a trade or PM
        if (this.selectedXProcess && this.selectedXSubProcess) {
            this.xLesson.insight = this.insight;
            this.xLesson.mandatory = this.mandatory;

            // tslint:disable-next-line:max-line-length
            xLessonWebservice
                .store(
                    this.xLesson,
                    this.selectedXSubProcess.id,
                    this.mandatory,
                    this.selectedTags,
                    this.experience.user_id,
                    this.selectedProject.id,
                    this.parentLesson as XLesson
                )
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 7000,
                        message: this.$t('toastMessages.store.experience').toString(),
                        type: 'is-success',
                    });

                    // The experience can now be deleted
                    experienceWebservice.remove(this.experience);

                    // Redirect to the list of experiences
                    this.$router.push('/experiences');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private validateXLesson() {
        if (this.selectedXProcess === null || !this.selectedXProcess.title || this.selectedXProcess.title === '') {
            this.errorMsg = 'xprocess';
            return 0;
        } else if (
            this.selectedXSubProcess === null ||
            !this.selectedXSubProcess.title ||
            this.selectedXSubProcess.title === ''
        ) {
            this.errorMsg = 'xsubprocess';
            return 0;
        } else if (!this.insight || this.insight === '') {
            this.errorMsg = 'lesson';
            return 0;
        } else {
            return true;
        }
    }

    private validatePMLesson() {
        if (this.selectedPMPhase === null || !this.selectedPMPhase.title || this.selectedPMPhase.title === '') {
            this.errorMsg = 'pmphase';
            return 0;
        } else if (
            this.selectedPMSubPhase === null ||
            !this.selectedPMSubPhase.title ||
            this.selectedPMSubPhase.title === ''
        ) {
            this.errorMsg = 'subphase';
            return 0;
        } else if (!this.insight || this.insight === '') {
            this.errorMsg = 'lesson';
            return 0;
        } else {
            return true;
        }
    }

    private validateTradeLesson() {
        if (!this.insight || this.insight === '') {
            this.errorMsg = 'lesson';
            return 0;
        } else if (this.selectedTrade === null || !this.selectedTrade.title || this.selectedTrade.title === '') {
            this.errorMsg = 'trade';
            return 0;
        } else if (this.selectedTopic === null || !this.selectedTopic.title || this.selectedTopic.title === '') {
            this.errorMsg = 'topic';
            return 0;
        } else if (!this.selectedPhases || this.selectedPhases.length === 0) {
            this.errorMsg = 'phase';
            return 0;
        } else {
            return true;
        }
    }
}
